import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {DashboardService} from '../../../../../api';
import {QueryKey} from '../../../../constants/query-key';
import {RouteUri} from '../../../../constants/route-uri';
import {formatSeconds, percentDelta} from '../../dashboard.utils';
import {DashboardKpiTile} from '../dashboard-kpi-tile/dashboard-kpi-tile';

@Component({
  selector: 'elcia-dashboard-time-tile',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DashboardKpiTile, TranslatePipe],
  templateUrl: './dashboard-time-tile.html',
  host: {class: 'block min-w-0'},
})
export class DashboardTimeTile {
  private readonly dashboardService = inject(DashboardService);

  protected readonly timesheetsLink = '/' + RouteUri.TIMESHEETS;

  private readonly statsQuery = injectQuery(() => ({
    queryKey: [QueryKey.DASHBOARD_TIMESHEET_STATS],
    queryFn: () => lastValueFrom(this.dashboardService.getDashboardTimesheetStats()),
  }));

  private readonly stats = computed(() => this.statsQuery.data()?.stats);

  protected readonly monthToDate = computed(() => formatSeconds(this.stats()?.monthToDateSeconds ?? 0));

  protected readonly timeDelta = computed(() => {
    const stats = this.stats();
    if (!stats) return null;
    return percentDelta(stats.monthToDateSeconds, stats.previousMonthToDateSeconds);
  });
}
